import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {IClient, IClientList} from "../../models/client"
import {IOrder, IOrderListPayload} from "../../models/order"
import {IValidationFieldErrorItem} from "../../models/validation"
import {AxiosError} from "axios"

interface ClientState {
  list: IClient[]
  orderHistory: {
    list: IOrder[]
    totalCount: number
    isLoading: boolean
  }
  client: IClient
  pages: number
  totalCount: number
  pageSize: number
  currentPage: number
  isLoading: boolean
  isAdding: boolean
  isUpdating: boolean
  isLoadingClient: boolean
  error: any
  fetchError: any
  fetchOrderHistoryError: any
}

const initialState: ClientState = {
  list: [],
  orderHistory: {
    list: [],
    totalCount: 0,
    isLoading: false
  },
  client: {
    id: 0,
    fio: "",
    phone: "",
    birthday: "",
    height: "",
    weight: "",
    comment: "",
    client_uuid: "",
    brigade: "",
    employers_id: "",
    status_id: 0,
    created_at: "",
    updated_at: ""
  },
  pages: 0,
  totalCount: 0,
  pageSize: 10,
  currentPage: 1,
  isLoading: false,
  isAdding: false,
  isUpdating: false,
  isLoadingClient: false,
  error: {},
  fetchError: "",
  fetchOrderHistoryError: ""
}

export const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    fetching(state) {
      state.isLoading = true
    },
    fetchSuccess(state, action: PayloadAction<IClientList>) {
      state.isLoading = false
      state.error = {}
      state.list = action.payload.list || []
      state.pages = action.payload.pages
      state.totalCount = action.payload.totalCount
    },
    fetchError(state, action: PayloadAction<AxiosError>) {
      state.isLoading = false

      if (action.payload.response?.status === 403) {
        state.fetchError = "У вас нет разрешения на эту операцию!"
      } else {
        state.fetchError = action.payload.message
      }
    },
    adding(state) {
      state.isAdding = true
    },
    addSuccess(state, action: PayloadAction<IClient>) {
      state.isAdding = false
    },
    updating(state) {
      state.isUpdating = true
    },
    updateSuccess(state, action: PayloadAction<IClient>) {
      state.isUpdating = false
    },
    saveError(state, action: PayloadAction<IValidationFieldErrorItem[]>) {
      state.isAdding = false
      const fieldErrors = action.payload

      if (fieldErrors && fieldErrors.length) {
        fieldErrors.forEach(error => {
          state.error[error.field] = error.message
        })
      }
    },
    fetchingClient(state) {
      state.isLoadingClient = true
      state.client = initialState.client
    },
    fetchClientSuccess(state, action: PayloadAction<IClient>) {
      state.isLoadingClient = false
      state.error = {}
      state.client = action.payload
    },
    fetchClientError(state, action: PayloadAction<Error>) {
      state.isLoadingClient = false
      state.error = action.payload
    },
    clearFieldError(state, action: PayloadAction<string>) {
      delete state.error[action.payload]
    },
    clearAllErrors(state) {
      state.error = {}
    },
    setCurrentPage(state, action: PayloadAction<number>) {
      state.currentPage = action.payload
    },
    fetchingOrderHistory(state){
      state.orderHistory.isLoading = true
      state.orderHistory.list = []
      state.orderHistory.totalCount = 0
    },
    fetchOrderHistorySuccess(state, action: PayloadAction<IOrderListPayload>) {
      state.orderHistory.isLoading = false
      state.orderHistory.list = action.payload.list || []
      state.orderHistory.totalCount = action.payload.totalCount
    },
    fetchOrderHistoryError(state, action: PayloadAction<Error>){
      state.orderHistory.isLoading = false
      state.fetchOrderHistoryError = action.payload
    }
  }
})

export default clientSlice.reducer